angular.module('app.controllers').controller('UsersListCtrl', function ($rootScope, $state, $timeout, $translate, notify, api, usersListFilter, usersList) {
    const vm = this;

    // konfiguracja filtra
    vm.filter = usersListFilter;
    vm.users = _.sortBy(usersList, ['fullname']);

    vm.filter.onRefresh(() => {
        const selectorsToShow = _.filter(_.map(vm.users, listFilter)).join(',');

        jQuery('.users-list > [data-user-id]').hide();
        jQuery(selectorsToShow).show();
    });

    const listFilter = (user) => {
        if (!user) {
            return false;
        }

        let name = true;
        let status = true;
        let job_id = true;
        let group_id = true;
        let area_id = true;

        // name
        if (vm.filter.fields.filter && vm.filter.fields.filter.value) {
            const parts = vm.filter.fields.filter.value.replace(/^\s+|\s+$/g).split(/\+\s+/g);
            const regExp = new RegExp(parts.join('|'), 'i');
            const subject = [user.fullname, user.job, user.stolcad_name].join(' ');

            name = regExp.test(subject);
        }

        // job_id
        if (vm.filter.fields.job_id && _.isArray(vm.filter.fields.job_id.value) && vm.filter.fields.job_id.value.length) {
            job_id = vm.filter.fields.job_id.value.includes(user.job_id ? user.job_id.toString() : '');
        }

        // group_id
        if (vm.filter.fields.group_id && _.isArray(vm.filter.fields.group_id.value) && vm.filter.fields.group_id.value.length) {
            const userGroups = _.map(user.groups, (group) => group.id.toString());

            group_id = _.intersection(userGroups, vm.filter.fields.group_id.value).length;
        }

        // area_id
        if (vm.filter.fields.area_id && _.isArray(vm.filter.fields.area_id.value) && vm.filter.fields.area_id.value.length) {
            const userAreas = _.map(user.areas, (area) => area.id.toString());

            area_id = _.intersection(userAreas, vm.filter.fields.area_id.value).length;
        }

        // status
        if (vm.filter.fields.status && _.isArray(vm.filter.fields.status.value) && vm.filter.fields.status.value.length) {
            status = vm.filter.fields.status.value.includes(user.status);
        }

        return name && status && job_id && group_id && area_id ? `.users-list > [data-user-id="${user.id}"]` : '';
    };
});
